import React, { useState } from 'react';
import s from './PromtBlocks.module.css';

import Slider from '../../../../shared/ui/slider/Slider';
import Button from '../../../../shared/ui/button/Button';
import { useAppDispatch } from '../../../../store/store';
import { useSelector } from 'react-redux';
import { selectSelectedImage } from '../../../../store/selectors/imageSelectors';
import { updateImage, wizardImageUrl } from '../../../../shared/api/imageProjectApi';
import { getImageSize } from '../../../../shared/helpers/imageHelpers';
import { toast } from 'react-toastify';
const WizardBlock: React.FC = () => {
    const [prompt, setPrompt] = useState('');
    const [realism, setRealism] = useState(false);
    const [creativity, setCreativity] = useState(1);
    const dispatch = useAppDispatch();
    const selectedImage = useSelector(selectSelectedImage);

    const handleGenerate = async () => {
        console.log('Generating with Image Wizard:', { prompt, realism, creativity });
        try {
            if (selectedImage?.image?.id)
                await dispatch(
                    wizardImageUrl({
                        imageId: selectedImage.image.id,
                        input: prompt,
                        creativity: creativity,
                    }),
                ).unwrap();
            toast.success('Image Wizard generated successfully');
        } catch (error: any) {
            toast.error(error?.message || 'Failed to generate image');
        }
    };

    return (
        <div className={s.container}>
            <p className={s.title}>Use our AI to Make specific changes within the image</p>

            <textarea
                className={s.input}
                placeholder="Type anything you want to change in the image."
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                rows={5}
                style={{
                    resize: 'vertical',
                    marginBottom: '20px',
                    minHeight: '80px',
                    maxHeight: '200px',
                }}
            />

            <label
                className={s.checkbox_label}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '20px',
                    marginTop: 0,
                    cursor: 'pointer',
                }}
            >
                <input
                    type="checkbox"
                    className={s.suggestion_checkbox}
                    checked={realism}
                    onChange={(e) => setRealism(e.target.checked)}
                    style={{
                        margin: 0,
                        width: '16px',
                        height: '16px',
                    }}
                />
                Enable realism mode
            </label>

            <div className={s.slider_item}>
                <p className={s.title}>Adjust creativity level</p>
                <div style={{ padding: '0 20px' }}>
                    <Slider min={0} max={2} step={1} value={creativity} onChange={setCreativity} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginTop: '2px',
                        marginBottom: '5px',
                        fontSize: '12px',
                        color: '#666',
                        position: 'relative',
                    }}
                >
                    <span
                        style={{
                            position: 'absolute',
                            left: '20px',
                            fontSize: '12px',
                        }}
                    >
                        0%
                    </span>
                    <span
                        style={{
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontSize: '12px',
                        }}
                    >
                        50%
                    </span>
                    <span
                        style={{
                            position: 'absolute',
                            right: '20px',
                            fontSize: '12px',
                        }}
                    >
                        100%
                    </span>
                </div>
                <p
                    style={{
                        fontSize: '10px',
                        color: '#666',
                        marginTop: '8px',
                        fontFamily: 'var(--main-font)',
                        lineHeight: '150%',
                    }}
                >
                    Tip: Higher levels are more creative but less obedient to the prompt
                </p>
            </div>

            <Button
                text="Generate"
                onClick={handleGenerate}
                style={{
                    backgroundColor: '#FFDD35',
                    width: '100%',
                    height: '40px',
                    marginTop: '20px',
                }}
                state={!prompt.trim() ? 'disabled' : 'enabled'}
            />
        </div>
    );
};

export default WizardBlock;
